import { getNewsPath, isValidNewsType } from '@dreamstack/feature-components'
import { useLocale } from '@dreamstack/i18n'
import type {
  FullNewsArticleFragment,
  NewsArticleLocaleSlugsFragment,
} from '@dreamstack/investors-graphql'
import { ArticleJsonLd } from 'next-seo'
import type { FunctionComponent } from 'react'

export const ArticleRichMarkup: FunctionComponent<React.PropsWithChildren<{
  article: FullNewsArticleFragment & NewsArticleLocaleSlugsFragment
}>> = ({ article }) => {
  const { slug, newsType } = article
  const locale = useLocale()

  if (!slug || !newsType) return null
  if (!isValidNewsType(locale, newsType)) return null

  const url = getNewsPath({ locale, slug, newsType })

  return (
    <>
      <ArticleJsonLd
        mainEntityOfPage={{ id: url, type: 'WebPage' }}
        url={url}
        title={article.title ?? ''}
        images={article.image?.url ? [article.image?.url] : []}
        datePublished={article.date}
        authorName="Accentro"
        publisher={{
          type: 'Organization',
          name: 'Accentro GmbH',
        }}
        description={article.previewText ?? ''}
      />
    </>
  )
}
